<template>
    <main class="main" :class="theme">
        <Menu /> 
        <Panel />
        <router-view />
        <transition name="fade">
            <SportsWindow v-if="showSports" />
        </transition>
        <transition name="fade">
            <Workplace v-if="getWorkplace" />
        </transition>
        <transition name="fade">
            <Edit />
        </transition>
        <Notifications />
        <ModalTheme />
        <Modal />
    </main>
</template>
<script>
import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import socketio from 'socket.io-client';

// import Menu from '@/components/Menu'
// import Panel from '@/components/Panel'
// import SportsWindow from '@/components/Filters/SportsWindow'
// import Edit from "@/components/Workplace/EditWorkplace";
// import Workplace from "@/components/Workplace/Workplace";
// import Notifications from "@/components/Modals/Notifications/index";
// import ModalTheme from "@/components/Modals/ModalTheme";
// import Modal from "@/components/Modals/Modal"
import PushService from '@/config/firebase_push.js'

export default {
    data: () => {
        return {
            theme: "sneakers_of_creator",
            socket: null
        }
    },
    components: {
        Menu: () => import('@/components/Menu'),
        Panel: () => import('@/components/Panel'),
        SportsWindow: () => import('@/components/Filters/SportsWindow'),
        Workplace: () => import("@/components/Workplace/Workplace"),
        Notifications: () => import("@/components/Modals/Notifications/index"),
        ModalTheme: () => import("@/components/Modals/ModalTheme"),
        Modal: () => import("@/components/Modals/Modal"),
        Edit: () => import("@/components/Workplace/EditWorkplace"),
    },
    computed: {
        showSports () {
            return this.$store.getters.sports;
        },
        getUser() {
          return this.$store.getters.getAuthUser
        },
        getWorkplace () {
			return this.$store.getters.workplace;
		},
        getFilters () {
            return this.$store.getters.getFilters
        },
        getToken() {
            return this.$axios.defaults.headers.common['Authorization']
        }
    },
    methods: {
      async connectSocket() {
          this.socket = await socketio.connect(this.$axios.defaults.baseURL, {
            query: {
                token: this.getToken
            },
            secure: true
        });

        Vue.use(new VueSocketIO({
            debug: process.env.VUE_APP_NODE_SIDE === 'dev',
            connection: this.socket,
            options: { 
                autoConnect: true,
                reconnection: true,
                reconnectionAttempts: 10
            }
        }));
      },
      indentificateUser() {
            let profile = JSON.parse(localStorage.getItem('user'));
            profile 
            ? (
                this.$store.dispatch('getAuthUser', profile), 
                this.$store.dispatch('setAuthUser', profile),
                PushService.getToken()
            )
            : '';
            this.$store.dispatch('notifications', { user: profile.id })
        },
    },
    created() {
        this.indentificateUser()
        this.connectSocket()
        this.theme = localStorage.getItem('theme') || this.theme;
        this.$store.dispatch('findAndSetTheme', this.theme);
    }
}
</script>